import {
  Box,
  Button,
  Container,
  Dialog,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  Typography
} from "@material-ui/core";
import CloseIconModal from "assets/icons/CloseIconModal";
import CustomSquareCheckbox from "components/CustomSquareCheckbox";
import { useState } from "react";
import imgPrazo from "../../assets/images/imgPrazo.png";
import "./index.scss";

interface ModalExperienciaConviteProps {
  open: boolean;
  onNext: () => void;
  onClose: (naoMostrar: boolean) => void;
  languageValues: any;
}

const ModalExperienciaConvite: React.FC<ModalExperienciaConviteProps> = ({
  open,
  onNext,
  onClose,
  languageValues,
}) => {
  const [naoMostrar, setNaoMostrar] = useState<boolean>(false);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      closeAfterTransition
      disableBackdropClick
      disableEscapeKeyDown
      PaperProps={{
        className: 'ModalExperiencia_paper'
      }}
      style={{
        zIndex: 9999
      }}
    >
      <Box>
        <DialogTitle className='ModalExperiencia_dialogTitle'>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography className='ModalExperiencia_titleModal'>
              {languageValues.modalAvisoGenericTitle}
            </Typography>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                onClose(naoMostrar);
              }}
              size="small"
            >
              <CloseIconModal style={{ width: 'auto', height: 25 }} />
            </IconButton>
          </Box>
        </DialogTitle>

        <DialogContent style={{ marginTop: 20 }}>
          <Grid container spacing={2} justifyContent='center' alignItems='flex-start' className="ModalExperiencia_convite-content-grid">
            <Grid item md={7}>
              <p className="ModalExperiencia_text-title-content">
                {languageValues.modalExperiencia.convite.title}
              </p>
              <p className='ModalExperiencia_text-content'>
                {languageValues.modalExperiencia.convite.content1}
              </p>
              <p className='ModalExperiencia_text-content'>
                {languageValues.modalExperiencia.convite.content2}
              </p>
              <p className='ModalExperiencia_text-content'>
                {languageValues.modalExperiencia.convite.content3}
              </p>
              <p className='ModalExperiencia_text-content'>
                {languageValues.modalExperiencia.convite.content4}
              </p>
            </Grid>
            <Grid item md={5} style={{ textAlign: 'right', margin: "auto", marginTop: 0 }}>
              <img src={imgPrazo} alt='imagen-relógio' style={{ maxWidth: "300px", height: "auto" }} draggable={false} />
            </Grid>
          </Grid>
        </DialogContent>

        <Container className='ModalExperiencia_dialogActions' disableGutters>
          <Box className="ModalExperiencia_container-box-btn">
            <div className="ModalExperiencia_checkboxConvite">
              <CustomSquareCheckbox
                id="ModalExperiencia_mostrarNovamenteCheckbox"
                label="Não mostrar novamente"
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setNaoMostrar(e.target.checked)}
                checked={naoMostrar}
                labelStyle={{ marginRight: '5px', textDecoration: 'underline', color: '#33820D' }}
              />
            </div>
            <div className="ModalExperiencia_btn">
              <Button
                className='ModalExperiencia_action-button'
                variant='contained'
                onClick={() => onClose(naoMostrar)}
                color="inherit"
                style={{ marginRight: '15px', marginLeft: '15px' }}
              >
                {languageValues.modalExperiencia.buttons.fechar}
              </Button>
            </div>

            <div className="ModalExperiencia_btn">
              <Button
                className='ModalExperiencia_action-button-green'
                variant='contained'
                onClick={onNext}
                color="inherit"
              >
                {languageValues.modalExperiencia.buttons.responder}
              </Button>
            </div>
          </Box>
        </Container>
      </Box>
    </Dialog>
  );
};

export default ModalExperienciaConvite;
